import { HealthRecordAdminLockoutDescriptor, HealthRecordConstants } from '@web/csl-lib-constants';
import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'adminLockout',
  standalone: true,
})
export class AdminLockoutPipe implements PipeTransform {
  transform(value: number): { code: string, tooltip: string } | null {

    // Value is a bit field: check each bit and add corresponding code and label

    let code = '';
    let tooltip = '';
    let desc: HealthRecordAdminLockoutDescriptor | undefined;

    const bitValues = HealthRecordConstants.adminLockoutOptions.map(l => l.value);

    bitValues.forEach(v => {
      desc = undefined;
      if(value & v) {
        desc = HealthRecordConstants.adminLockoutOptions.find(l => l.value == v);
        if(desc) {
          code += desc.code;
          tooltip += desc.description + '\n';
        }
      }
    })

    return { code: code, tooltip: tooltip };
  }
}
